import _Button from "@arco-design/web-react/es/Button";
import _Grid from "@arco-design/web-react/es/Grid";
import _Checkbox from "@arco-design/web-react/es/Checkbox";
import _Select from "@arco-design/web-react/es/Select";
import _Space from "@arco-design/web-react/es/Space";
import _Radio from "@arco-design/web-react/es/Radio";
import _Popover from "@arco-design/web-react/es/Popover";
import _Input from "@arco-design/web-react/es/Input";
import _Spin from "@arco-design/web-react/es/Spin";
import _Tag from "@arco-design/web-react/es/Tag";
import _useRequest from "@byted/hooks/es/useRequest";
import _Form from "@arco-design/web-react/es/Form";
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function sent() {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (_) {
      try {
        if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
        if (y = 0, t) op = [op[0] & 2, t.value];
        switch (op[0]) {
          case 0:
          case 1:
            t = op;
            break;
          case 4:
            _.label++;
            return {
              value: op[1],
              done: false
            };
          case 5:
            _.label++;
            y = op[1];
            op = [0];
            continue;
          case 7:
            op = _.ops.pop();
            _.trys.pop();
            continue;
          default:
            if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
              _ = 0;
              continue;
            }
            if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
              _.label = op[1];
              break;
            }
            if (op[0] === 6 && _.label < t[1]) {
              _.label = t[1];
              t = op;
              break;
            }
            if (t && _.label < t[2]) {
              _.label = t[2];
              _.ops.push(op);
              break;
            }
            if (t[2]) _.ops.pop();
            _.trys.pop();
            continue;
        }
        op = body.call(thisArg, _);
      } catch (e) {
        op = [6, e];
        y = 0;
      } finally {
        f = t = 0;
      }
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) {
      ar.push(r.value);
    }
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
import React, { useState, useEffect } from 'react';
import Upload from '@src/pages/common/commonUpload';
import style from './style.less';
import { IconInfoCircleFill } from '@arco-design/web-react/icon';
import { getPkgVersions } from '@src/utils/api/common';
import { GetThemeDetail } from '@src/utils/api/theme';
import IconReact from '@src/assets/svg/react.svg';
import IconVue from '@src/assets/svg/vue.svg';
import useLocale from '@src/hooks/useLocale';
import { themeDepLibrary, themeOperate } from '@src/utils/constants';
import SelectSpace from './selectSpace';
import ByteTreeSelector, { PermissionFormItem } from '@cloud-ui-react/byte-tree-selector';
import { CloudConfigProvider } from '@bytecloud/react-lib';
import axios from 'axios';
import { isByteDanceNet } from '@src/utils/isBT';
import EnableFeature from '@src/common/enableFeature';
import isEqual from 'lodash/isEqual';
var npmSource = {
  react: '@arco-design/arco-ui-dist',
  vue: '@arco-design/arco-vue-ui-dist'
};
var ThemeForm = function ThemeForm(props) {
  var _a, _b, _c, _d;
  var _e = props.operate,
    operate = _e === void 0 ? '' : _e;
  var _f = __read(_Form.useForm(), 1),
    form = _f[0];
  var _g = __read(useState(true), 2),
    optionsLoading = _g[0],
    setOptionLoading = _g[1];
  var _h = __read(useState({
      react: [],
      vue: []
    }), 2),
    options = _h[0],
    setOptions = _h[1];
  var _j = _useRequest(function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var data;
        var _a, _b, _c, _d;
        return __generator(this, function (_e) {
          switch (_e.label) {
            case 0:
              return [4, GetThemeDetail({
                themeId: (_a = props.initialValue) === null || _a === void 0 ? void 0 : _a.themeId
              })];
            case 1:
              data = _e.sent();
              form.setFieldsValue(__assign(__assign({}, data), {
                themeName: operate === themeOperate.copy ? '' : data.themeName,
                belongSpace: Object.keys(data.belongSpace).length ? data.belongSpace : undefined,
                extendType: ((_b = props.initialValue) === null || _b === void 0 ? void 0 : _b.extendType) || data.extendType,
                byteTreeNodeId: ((_c = props.initialValue) === null || _c === void 0 ? void 0 : _c.byteTreeNodeId) ? Number((_d = props.initialValue) === null || _d === void 0 ? void 0 : _d.byteTreeNodeId) : null
              }));
              return [4, getVersions()];
            case 2:
              _e.sent();
              return [2, data];
          }
        });
      });
    }, {
      auto: !!((_a = props.initialValue) === null || _a === void 0 ? void 0 : _a.themeId)
    }),
    loadingInit = _j.loading,
    originThemeDetail = _j.data;
  var _k = _useRequest(function () {
      return __awaiter(void 0, void 0, void 0, function () {
        var values, changedKeys;
        return __generator(this, function (_a) {
          switch (_a.label) {
            case 0:
              return [4, form.validate()];
            case 1:
              values = _a.sent();
              changedKeys = Object.keys(values).filter(function (key) {
                return !isEqual(values[key], originThemeDetail === null || originThemeDetail === void 0 ? void 0 : originThemeDetail[key]);
              });
              return [4, props.onSubmit(changedKeys.reduce(function (t, key) {
                t[key] = values[key];
                return t;
              }, {}))];
            case 2:
              return [2, _a.sent()];
          }
        });
      });
    }),
    loading = _k.loading,
    run = _k.run;
  var _l = __read(useState(''), 2),
    cloudJwt = _l[0],
    setCloudJwt = _l[1];
  useEffect(function () {
    isByteDanceNet() && axios.get("https://arco."+a7r51826g2d0u693s('$1c1c01*cFh$bWhp-l%1c1RHMDFiR1JI%m5s-%0xWj-')+"/common/api/auth/jwt", {
      withCredentials: true
    }).then(function (res) {
      setCloudJwt(res.headers['x-jwt-token']);
    })["catch"](function (e) {
      return console.log('erroeroeroreoreo', e);
    });
  }, []);
  var _m = useLocale(undefined, props.lang),
    t = _m.t,
    lang = _m.lang;
  var getVersions = function getVersions() {
    return __awaiter(void 0, void 0, void 0, function () {
      var fetchData, _a, reactVersions, vueVersions, _options;
      var _b, _c;
      return __generator(this, function (_d) {
        switch (_d.label) {
          case 0:
            fetchData = function fetchData(depLibrary) {
              var dep = form.getFieldValue('depLibrary');
              if (dep && dep !== depLibrary) {
                return [];
              }
              var name = npmSource[depLibrary === themeDepLibrary.vue ? 'vue' : 'react'];
              return getPkgVersions({
                packageName: name
              }).then(function (res) {
                var versions = res.versions;
                var options = {};
                versions.filter(function (x) {
                  return x.indexOf('-') === -1;
                }).map(function (key) {
                  var label = key.replace(/\d$/, 'x');
                  options[label] = options[label] || {
                    value: key,
                    label: label + "(" + key + ")"
                  };
                });
                return Object.values(options);
              });
            };
            return [4, Promise.all([fetchData(themeDepLibrary.react), fetchData(themeDepLibrary.vue)])];
          case 1:
            _a = __read.apply(void 0, [_d.sent(), 2]), reactVersions = _a[0], vueVersions = _a[1];
            setOptionLoading(false);
            setOptions({
              react: reactVersions,
              vue: vueVersions
            });
            if (!form.getFieldValue('useLatest') && !((_b = props.initialValue) === null || _b === void 0 ? void 0 : _b.depVersion)) {
              _options = form.getFieldValue('depLibrary') === themeDepLibrary.vue ? vueVersions : reactVersions;
              form.setFieldValue('depVersion', (_c = _options[0]) === null || _c === void 0 ? void 0 : _c.value);
            }
            return [2];
        }
      });
    });
  };
  useEffect(function () {
    var _a;
    !((_a = props.initialValue) === null || _a === void 0 ? void 0 : _a.themeId) && getVersions();
  }, []);
  var TipContent = function TipContent() {
    if (lang === 'en-US') return /*#__PURE__*/React.createElement("span", null, "The current theme applies to projects created by ", /*#__PURE__*/React.createElement(_Tag, null, themeDepLibrary['react']), " or", /*#__PURE__*/React.createElement(_Tag, null, themeDepLibrary['vue']), /*#__PURE__*/React.createElement("br", null), "Once it is determined, it cannot be modified!");
    return /*#__PURE__*/React.createElement("span", null, "\u5F53\u524D\u4E3B\u9898\u5E94\u7528\u5728 ", /*#__PURE__*/React.createElement(_Tag, null, themeDepLibrary['react']), " \u6216 ", /*#__PURE__*/React.createElement(_Tag, null, themeDepLibrary['vue']), " \u6240\u521B\u5EFA\u7684\u9879\u76EE\u3002 \u4E00\u65E6\u786E\u5B9A\u4E0D\u53EF\u4FEE\u6539\uFF01");
  };
  return /*#__PURE__*/React.createElement(_Spin, {
    loading: loadingInit,
    style: {
      display: 'block'
    }
  }, /*#__PURE__*/React.createElement(_Form, {
    className: style['theme-form'],
    onClick: function onClick(e) {
      e.stopPropagation();
    },
    disabled: props.disabled,
    initialValues: {
      useLatest: ((_b = props.initialValue) === null || _b === void 0 ? void 0 : _b.depVersion) ? false : true,
      depLibrary: ((_c = props.initialValue) === null || _c === void 0 ? void 0 : _c.depLibrary) || themeDepLibrary['react']
    },
    form: form,
    onSubmit: run,
    wrapperCol: {
      style: {
        flex: 1,
        overflow: 'hidden'
      },
      span: 24
    },
    labelCol: {
      style: {
        flexBasis: 124
      }
    }
  }, props.header, /*#__PURE__*/React.createElement(_Form.Item, {
    label: t['theme.create.form.themeName'],
    field: "themeName",
    rules: [{
      required: true,
      message: t['theme.create.form.themeName.required']
    }]
  }, /*#__PURE__*/React.createElement(_Input, {
    placeholder: t['theme.create.form.themeName.placeholder']
  })), /*#__PURE__*/React.createElement(EnableFeature, null, /*#__PURE__*/React.createElement(SelectSpace, {
    lang: props.lang,
    hidden: props.hideSpace,
    form: form,
    disabled: operate === 'edit' && Boolean(originThemeDetail === null || originThemeDetail === void 0 ? void 0 : originThemeDetail.belongSpace.spaceId)
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    label: t['theme.create.form.description'],
    field: "description",
    rules: [{
      type: 'string',
      maxLength: 100,
      message: t['theme.create.form.themeName.maxLength']
    }]
  }, /*#__PURE__*/React.createElement(_Input.TextArea, {
    maxLength: 100,
    placeholder: t['theme.create.form.description.placeholder'],
    rows: 2
  })), /*#__PURE__*/React.createElement(_Form.Item, {
    label: /*#__PURE__*/React.createElement("span", null, t['theme.create.form.depLibrary'], /*#__PURE__*/React.createElement(_Popover, {
      content: /*#__PURE__*/React.createElement(TipContent, null)
    }, /*#__PURE__*/React.createElement(IconInfoCircleFill, null))),
    disabled: !!((_d = props.initialValue) === null || _d === void 0 ? void 0 : _d.depLibrary),
    rules: [{
      required: true
    }],
    field: "depLibrary",
    extra: /*#__PURE__*/React.createElement(_Form.Item, {
      shouldUpdate: true,
      noStyle: true
    }, function (values) {
      return /*#__PURE__*/React.createElement("span", null, values['depLibrary']);
    })
  }, /*#__PURE__*/React.createElement(_Radio.Group, {
    className: style['radio-group'],
    type: "button",
    onChange: function onChange(v) {
      var _a, _b;
      var versionOptions = v === themeDepLibrary.vue ? options.vue : options.react;
      if ((_a = versionOptions[0]) === null || _a === void 0 ? void 0 : _a.value) {
        form.setFieldValue('depVersion', (_b = versionOptions[0]) === null || _b === void 0 ? void 0 : _b.value);
      }
      getVersions();
    }
  }, /*#__PURE__*/React.createElement(_Radio, {
    value: themeDepLibrary['react']
  }, /*#__PURE__*/React.createElement(IconReact, {
    className: style['react-icon']
  }), "React"), /*#__PURE__*/React.createElement(_Radio, {
    value: themeDepLibrary['vue']
  }, /*#__PURE__*/React.createElement(IconVue, {
    className: style['vue-icon']
  }), "Vue"))), /*#__PURE__*/React.createElement(_Form.Item, {
    rules: [{
      required: true
    }],
    label: /*#__PURE__*/React.createElement(_Space, {
      size: 4
    }, t['theme.create.form.depVersion'], /*#__PURE__*/React.createElement(_Popover, {
      content: /*#__PURE__*/React.createElement("span", null, t['theme.create.form.depVersion.tip1'], /*#__PURE__*/React.createElement("br", null), t['theme.create.form.depVersion.tip2'])
    }, /*#__PURE__*/React.createElement(IconInfoCircleFill, null))),
    shouldUpdate: true
  }, function (values) {
    var _a;
    var versionOptions = values.depLibrary === themeDepLibrary.vue ? options.vue : options.react;
    return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(_Form.Item, {
      style: {
        marginBottom: 0
      },
      field: "useLatest"
    }, /*#__PURE__*/React.createElement(_Radio.Group, {
      options: [{
        label: t['theme.create.form.depVersion.option1'],
        value: true
      }, {
        label: t['theme.create.form.depVersion.option2'],
        value: false
      }]
    })), !values.useLatest && /*#__PURE__*/React.createElement(_Form.Item, {
      noStyle: {
        showErrorTip: true
      },
      field: "depVersion",
      initialValue: (_a = versionOptions[0]) === null || _a === void 0 ? void 0 : _a.value,
      rules: [{
        required: true,
        message: t['theme.create.form.depVersion.required']
      }]
    }, /*#__PURE__*/React.createElement(_Select, {
      loading: optionsLoading,
      style: {
        marginTop: 12
      },
      allowClear: true,
      options: versionOptions
    })));
  }), isByteDanceNet() && cloudJwt && /*#__PURE__*/React.createElement(CloudConfigProvider, {
    value: {
      domainID: 'online',
      locale: lang.slice(0, 2)
    }
  }, /*#__PURE__*/React.createElement(PermissionFormItem, {
    label: /*#__PURE__*/React.createElement("span", null, t['theme.create.form.bytetree.node'], /*#__PURE__*/React.createElement(_Popover, {
      content: t['theme.create.form.bytetree.tip']
    }, /*#__PURE__*/React.createElement(IconInfoCircleFill, null))),
    field: "byteTreeNodeId",
    role: "groot.resource.manager.cn",
    permission: "groot.nodes.create_resource",
    jwt: cloudJwt,
    className: "unstyledLink",
    username: window.__user__.username,
    errorMessage: /*#__PURE__*/React.createElement("span", {
      className: style['nopermission']
    }, t['theme.create.form.bytetree.nopermission'])
  }, /*#__PURE__*/React.createElement(ByteTreeSelector, {
    renderFormatType: "path",
    jwt: cloudJwt
  }))), /*#__PURE__*/React.createElement(_Form.Item, {
    label: t['theme.create.form.logo'],
    field: "logo"
  }, /*#__PURE__*/React.createElement(Upload, null)), /*#__PURE__*/React.createElement(_Form.Item, {
    label: t['theme.create.form.cover'],
    field: "cover",
    className: style.cover
  }, /*#__PURE__*/React.createElement(Upload, {
    drag: true,
    tip: /*#__PURE__*/React.createElement("ul", {
      className: style.tip
    }, /*#__PURE__*/React.createElement("li", null, t['theme.create.form.cover.tip1']), /*#__PURE__*/React.createElement("li", null, t['theme.create.form.cover.tip2']), /*#__PURE__*/React.createElement("li", null, t['theme.create.form.cover.tip3']))
  })), /*#__PURE__*/React.createElement(_Form.Item, null, /*#__PURE__*/React.createElement(_Space, {
    size: "small"
  }, /*#__PURE__*/React.createElement(_Form.Item, {
    field: "allowCopy",
    triggerPropName: "checked",
    label: /*#__PURE__*/React.createElement("span", null, t['theme.create.form.allowCopy'], /*#__PURE__*/React.createElement(_Popover, {
      content: t['theme.create.form.allowCopy.tip']
    }, /*#__PURE__*/React.createElement(IconInfoCircleFill, null)))
  }, /*#__PURE__*/React.createElement(_Checkbox, null, t['theme.create.form.allow.text'])))), /*#__PURE__*/React.createElement(_Grid.Row, {
    justify: "end",
    className: style.footer
  }, /*#__PURE__*/React.createElement(_Button, {
    disabled: loading,
    onClick: props.onCancel,
    style: {
      marginRight: 8
    }
  }, t['theme.create.form.cancel']), /*#__PURE__*/React.createElement(_Button, {
    disabled: props.disabled,
    htmlType: "submit",
    loading: loading,
    type: "primary"
  }, t['theme.create.form.comfirm']))));
};
export default ThemeForm;